// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Form, FormItem, IFormInstance } from '@/components';
import { Button, TextArea } from '@/ui';
import { StyledButtons } from './FaqFormStyles';

// Helpers
import { FaqFieldsNames, TFaqFormValues } from '../../helpers';
import { useFaqFormRules } from '../../hooks';

type TFaqFormProps = {
  initialValues?: Partial<TFaqFormValues>;
  onSubmit: (values: TFaqFormValues) => void;
  onReset: () => void;
  isLoading?: boolean;
  submitText?: string;
  formInstance: IFormInstance;
};

const FaqForm: FC<TFaqFormProps> = ({ initialValues, isLoading, formInstance, onSubmit, onReset, submitText }) => {
  const { t } = useTranslation();
  const rules = useFaqFormRules();

  return (
    <Form form={formInstance} onReset={onReset} onFinish={onSubmit} initialValues={initialValues}>
      <FormItem name={FaqFieldsNames.QUESTION} rules={rules[FaqFieldsNames.QUESTION]} label={t('label_question_one')}>
        <TextArea placeholder={t('label_question_one')} rows={2} />
      </FormItem>
      <FormItem name={FaqFieldsNames.ANSWER} rules={rules[FaqFieldsNames.ANSWER]} label={t('label_answer_one')}>
        <TextArea placeholder={t('label_answer_one')} rows={5} />
      </FormItem>
      <StyledButtons>
        <Button type="primary" htmlType="submit" block loading={isLoading}>
          {submitText ?? t('create_btn')}
        </Button>
        <Button onClick={onReset} htmlType="button" block>
          {t('cancel_btn')}
        </Button>
      </StyledButtons>
    </Form>
  );
};

export default FaqForm;
